import { Checkbox, IFormRender } from '@busybusy/webapp-react-ui';
import HeaderText from 'containers/settings/components/HeaderText/HeaderText';
import { t } from 'i18next';
import { isNil } from 'lodash';
import { useState } from 'react';
import { JobCostingPromptOptions } from '__generated__/graphql';
import { IJobCostingPromptFormData } from '../../forms/JobCostingPromptForm';

export interface IJobCostingPromptFormFieldsProps<T extends IJobCostingPromptFormData> {
  form: IFormRender<T>;
}

interface IJobCostingPromptFormFieldsFormData {
  enabled: boolean;
  required: boolean;
}

function JobCostingPromptFormFields<T extends IJobCostingPromptFormData>({
  form,
}: IJobCostingPromptFormFieldsProps<T>) {
  const [settings, setSettings] = useState<IJobCostingPromptFormFieldsFormData>(getInitialData());

  function getInitialData() {
    if (!isNil(form.state.data.jobCostingPrompt)) {
      if (form.state.data.jobCostingPrompt === JobCostingPromptOptions.On) {
        return { enabled: true, required: false };
      } else if (form.state.data.jobCostingPrompt === JobCostingPromptOptions.Required) {
        return { enabled: true, required: true };
      }
    }
    return { enabled: false, required: false };
  }

  return (
    <>
      <Checkbox
        key={'enabled'}
        className="my-4"
        checked={settings.enabled}
        label={
          <HeaderText title={t('Enable Job Costing Prompt')}>
            <span>
              {t(
                `When clocking out, prompt the employees to use the job costing tool to edit the time spent on projects, cost codes and equipment. They will not be able to edit their total time worked for the day if they do not already have permissions to do so.`
              )}
            </span>
          </HeaderText>
        }
        onChange={(value) => {
          setSettings({ ...settings, enabled: value });
          form.state.data.jobCostingPrompt = value === true ? JobCostingPromptOptions.On : JobCostingPromptOptions.Off;
        }}
      />
      {settings.enabled && (
        <Checkbox
          key={'required'}
          className="my-6"
          checked={settings.required}
          label={
            <HeaderText title={t('Require Job Costing Prompt')}>
              <span>{t(`Require employees to assign job costing to all time entries before clocking out.`)}</span>
            </HeaderText>
          }
          onChange={(value) => {
            setSettings({ ...settings, required: value });
            form.state.data.jobCostingPrompt =
              value === true ? JobCostingPromptOptions.Required : JobCostingPromptOptions.On;
          }}
        />
      )}
    </>
  );
}

export default JobCostingPromptFormFields;
